import Swiper from 'swiper/bundle';
import SmoothScroll from "smooth-scroll";
import { Navigations } from './navigations';
import { Fadein } from './fadein';
const SmartPhoto = require('smartphoto');
import 'smartphoto/css/smartphoto.min.css';

const init = () => {
	const carousel = new Swiper(".mainvisual", {
		spaceBetween: 30,
		effect: "fade",
		loop: true,
		speed: 800,
		autoplay: {
		  delay: 2500,
		  disableOnInteraction: false,
		},
	});
	
	// Facility gallery
	const gallery = new Swiper(".facilities_gallery", {
		spaceBetween: 30,
		effect: "fade",
		speed: 800,
	});
	// Gallery navigation
	const galleryButtons = document.querySelectorAll(".facility__gallery--button");
	if (galleryButtons.length>0) {
		galleryButtons[0].querySelector("button").classList.add("is-active");
		galleryButtons.forEach((el) => {
			el.addEventListener("click", ()=> {
				const button = el.querySelector("button");
				const slide = button.dataset.slide;
				gallery.slideTo(slide);
				galleryButtons.forEach( (buttonDiv) => {
					const button = buttonDiv.querySelector("button");
					button.classList.remove("is-active");
				});
				button.classList.toggle("is-active");
			})
		});
	}
	
	const scroll = new SmoothScroll('a[href*="#"]', {
		speed: 300,
		easing: 'easeOutQuint',
		header: '[data-scroll-header]'
	});
	Navigations();
	Fadein();
	const zoom = new SmartPhoto(".js-smartphoto");
}

//initcl
if (document.readyState !== "loading") {
	init();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		init();
	})
}
